import { useFormatToSoftDecimal } from '@dreamstack/i18n'
import dynamic from 'next/dynamic'
import { useCallback } from 'react'

const ResponsiveLine = dynamic(
  () => import('@nivo/line').then((mod) => mod.ResponsiveLine),
  {
    ssr: false,
  }
)

const maxY = 1_500_000
const minY = -500_000

const colors = ['#73c49f', '#eb6744']

export const BuyToLetGraph = ({ data }: { data: any }) => {
  const formatNumber = useFormatToSoftDecimal({
    minFractionDigits: 0,
    maxFractionDigits: 1,
  })

  const formatEuro = useCallback(
    (amount: number): string => {
      const divisor = amount >= 1_000_000 ? 1_000_000 : 1_000
      const fixed = amount >= 1_000_000 ? 1 : 0
      let formatted = (amount / divisor).toFixed(fixed)
      formatted = formatNumber(formatted)
      const preSuffix =
        Math.abs(amount) >= 1_000_000
          ? 'M'
          : Math.abs(amount) >= 1_000
          ? 'K'
          : ''
      const suffix = ' EUR'
      return `${formatted}${preSuffix}${suffix}`
    },
    [formatNumber]
  )
  return (
    <ResponsiveLine
      enableArea={true}
      curve="linear"
      theme={{
        text: {
          fontSize: 13,
          fontFamily: 'Montserrat',
        },
      }}
      colors={colors}
      data={data}
      enableCrosshair={false}
      margin={{ top: 50, bottom: 64, left: 100, right: 30 }}
      xScale={{ type: 'linear' }}
      yScale={{
        type: 'linear',
        // max: maxY,
        // min: minY,
        stacked: false,
        reverse: false,
      }}
      enableGridX={false}
      gridXValues={[0, 10, 20, 30]}
      // gridYValues={[-500_000, 0, 500_000, 1_000_000, 1_500_000]}
      yFormat={formatEuro as any}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 24,
        tickRotation: 0,
        legendOffset: 36,
        legendPosition: 'middle',
        tickValues: [0, 10, 20, 30],
        format: (value) => (value === 30 ? '30 Years' : value),
      }}
      axisLeft={{
        format: (value) => formatEuro(value),
        tickSize: 0,
        tickPadding: 24,
        tickRotation: 0,
        legendOffset: -40,
        legendPosition: 'middle',
        // tickValues: [-500_000, 0, 500_000, 1_000_000, 1_500_000],
      }}
      pointSize={0}
      pointColor={{ from: 'color' }}
      pointBorderWidth={0}
      pointBorderColor={{ from: 'color' }}
      pointLabelYOffset={-12}
      tooltip={({ point }) => {
        const pluralizedLabel = point.data.x === 1 ? 'Year' : 'Years'
        const xTrimmed = (point.data.x as number)
          .toFixed(point.data.y === 0 ? 2 : 0)
          .toString()
        return (
          <div
            style={{
              background: 'white',
              padding: '6px 8px',
              border: '1px solid rgba(0,0,0,0.1)',
              display: 'flex',
              alignItems: 'center',
              borderRadius: '2px',
            }}
          >
            <div
              style={{
                backgroundColor: point.seriesColor,
                height: '12px',
                width: '12px',
                marginRight: '8px',
              }}
            />
            <span>
              {`After ${xTrimmed} ${pluralizedLabel}: `}
              <strong>{point.data.yFormatted}</strong>
            </span>
          </div>
        )
      }}
      useMesh={true}
    />
  )
}
